module.exports = __webpack_public_path__ + "static/media/download_old.71389802.svg";